exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".header-f6896{margin-bottom:2.4rem;text-align:center}.header-f6896 h1{color:#191919;font:500 2.4rem/3.6rem XfinityStandard,Helvetica,Arial,sans-serif;letter-spacing:.02rem;font-weight:500;margin:0 0 .6rem}@media(max-width: 530px){.header-f6896 h1{font-size:2rem;line-height:3rem}}.header-f6896 p{margin:0 0 .6rem}", ""]);

// Exports
exports.locals = {
	"header": "header-f6896"
};